import { render, staticRenderFns } from "./comments.vue?vue&type=template&id=8854d166&scoped=true"
import script from "./comments.vue?vue&type=script&lang=js"
export * from "./comments.vue?vue&type=script&lang=js"
import style0 from "./comments.vue?vue&type=style&index=0&id=8854d166&prod&scoped=true&lang=scss"
import style1 from "./comments.vue?vue&type=style&index=1&id=8854d166&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8854d166",
  null
  
)

export default component.exports